//import Accordion from "@bsw/nightingale";
import React from 'react';
import { Collapse } from 'reactstrap';
import { Icon, Typography } from '../../index';
import './accordion.scss';

export const AccordionItem = ({
    content,
    disabled,
    heading,
    headerAs = <button type="button" disabled={disabled}></button>,
    toggle = () => { },
    open
}) => {

    const accordionItemClasses = [
        `bsw-accordion__item`,
        `${open ? ' active' : ''}`
    ].join(' ');

    const headerContent = heading ? <div className="bsw-accordion__header-content">{heading}</div> : null;

    const headerArrow = content 
        ? <div className="bsw-accordion__header-arrow">
            <Icon name={open ? "chevron-up" : "chevron-down"}
                color={disabled ? '$color-secondary-a4' : "$color-primary-a2"}
                size="medium" />
          </div>
        : "";

    const element = React.cloneElement(
        headerAs,
        {
            onClick: (e) => { toggle(e) }
        },
        headerContent,
        headerArrow
    );

    return <>{(content || heading) &&
        <div className={accordionItemClasses}>
            {heading &&
                <div className="bsw-accordion__header">
                    <Typography
                        type="body-02"
                        tag="div"
                        color={disabled ? '$color-secondary-a4' : undefined}
                    >
                        {element}
                    </Typography>
                </div>
            }
            {content && <Collapse
                className="bsw-accordion__body"
                isOpen={open}
            >
                <Typography
                    type="body-02"
                    tag="div"
                >
                    {content}
                </Typography>
            </Collapse>
            }
        </div>
    }</>;
}